module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"wrong-route":{"header":{"title":"Oops, looks like this page does not exist"}}},"es":{"wrong-route":{"header":{"title":"Oops, parece que esta página no existe"}}},"fr":{"wrong-route":{"header":{"title":"Oups, il semble que cette page n\u0027existe pas"}}},"pt":{"wrong-route":{"header":{"title":"Oops, parece que esta página não existe"}}},"de":{"wrong-route":{"header":{"title":"Ups, es sieht so aus, als würde diese Seite nicht existieren"}}},"nl":{"wrong-route":{"header":{"title":"Oeps, het lijkt erop dat deze pagina niet bestaat"}}}}')
  delete Component.options._Ctor
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@intlify/vue-i18n-loader/lib!./node_modules/vue-loader/lib/selector.js?type=customBlocks&index=0!./src/modules/app/components/WrongRoute.vue
// module id = 5I7J
// module chunks = 10